import { BaseLink, mediaQueries, style } from '@do/walrus';
import * as React from 'react';
import styled from 'styled-components';

import {
  getDeveloperIcon,
  getDeveloperName,
  getSupport
} from '../../selectors';

export const SUPPORT_DETAILS_HASH = 'support';

const Support = styled.div`
  ${mediaQueries.largeMin} {
    border-bottom: 1px solid ${style.colors.shadesOfGrey['4']};
    padding-bottom: 53px;
    margin-bottom: 53px;
  }
`;

const SupportTitle = styled.span`
  margin-right: 8px;
  display: inline-block;
`;

const SupportedByIcon = styled.img`
  width: 16px;
  margin-right: 3px;
`;

interface Props {
  app: any;
}

const SupportDetails: React.FC<Props> = ({ app }) => {
  const support = getSupport(app);

  if (!support) {
    return null;
  }

  const developerName = getDeveloperName(app);
  const developerIcon = getDeveloperIcon(app);
  const { terms_url: termsUrl, hours, url, email } = support;

  return (
    (termsUrl || hours || url || email || developerName) && (
      <Support>
        <>
          <h4 id={SUPPORT_DETAILS_HASH}>Support Details</h4>
          {developerName && (
            <>
              <SupportTitle>Supported By:</SupportTitle>
              {developerIcon && (
                <SupportedByIcon src={developerIcon} alt={developerName} />
              )}
              <span>{developerName}</span>
              <br />
            </>
          )}

          {termsUrl && (
            <>
              <SupportTitle>Terms of Service:</SupportTitle>
              <BaseLink to={termsUrl}>{termsUrl}</BaseLink>
              <br />
            </>
          )}

          {hours && (
            <>
              <SupportTitle>Hours:</SupportTitle>
              <span>{hours}</span>
              <br />
            </>
          )}

          {url && (
            <>
              <SupportTitle>Support URL:</SupportTitle>
              <BaseLink to={url}>{url}</BaseLink>
              <br />
            </>
          )}

          {email && (
            <>
              <SupportTitle>Support Email:</SupportTitle>
              <a
                href={`mailto:${email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {email}
              </a>
            </>
          )}
        </>
      </Support>
    )
  );
};

export default SupportDetails;
